export function onlyUnique(value: any, index: number, self: any) {
  return self.indexOf(value) === index;
}
